export default "{\n    \"sectionLabels\": {\n        \"favouriteVendors\": \"Vendors\"\n    }\n}\n"